var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('general-variation-settings',{attrs:{"variations":_vm.adCreative.generalVariations},on:{"update":_vm.updateGeneralVariations}}),_c('url-variation-settings',{attrs:{"variations":_vm.adCreative.urlTagsVariations},on:{"update":_vm.updateUrlVariations}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }